import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RootService } from '../shared/services/root.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import { ApiService } from '../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
declare var $: any;

@Component({
  selector: 'app-explore-product-build-vehicle',
  templateUrl: './explore-product-build-vehicle.component.html',
  styleUrls: ['./explore-product-build-vehicle.component.scss']
})
export class ExploreProductBuildVehicleComponent implements OnInit {

  environment1 =environment.s3bucket.url;
  LoginFormGroup: any;
  dealerLen: any = [];
  sub: Subscription = new Subscription();


  constructor(private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private storageService: RootService, private fb: FormBuilder,
    private apiService: ApiService,private route: ActivatedRoute,
    private toastrService: ToastrService,
    private behaviorService: BehaviourSubjectService) {
      this.sub.add(this.route.queryParams.subscribe((params) => {
        if (params['dealer']) {
          if (isPlatformBrowser(this.platformId)) {

            localStorage.setItem("dealercd", params['dealer']);
          }
            this.getDealer()
          
        }
      }));
     }

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {

    $(document).ready(function () {
      $('#WelcomeModal').modal('show');
    });
  }
  }

  getDealer() {
    let data;
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem("dealername")
    
       data = {
        "dealer_code": localStorage.getItem("dealercd"),
        "action_type": "dropdown"
    };
  }
      this.sub.add(this.apiService.getDealerList(data).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            this.dealerLen = response?.data;
            if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem("dealername",  (this.dealerLen[0].organization_name + '_' + this.dealerLen[0].dealer_code))
            }
            this.behaviorService.dealerName.next(true)

          }
        },
        error: (error) => {
          this.toastrService.warning(error.data.msg);
        },
        complete: () => {
        }
      })
      );
  }
  resetFormGroup() {
    this.LoginFormGroup = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    })
  }


  onExplorePageClick() {
    
    if (this.storageService.getUserData()) {
      this.router.navigateByUrl('advancesearch')
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', '/advancesearch')
      }
      this.router.navigate(['/login/']);
    }
  
  }

  onBuildNowClick() {
    

    if (this.storageService.getUserData()) {
      this.router.navigateByUrl('configurator-home')
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', '/configurator-home')
      }
      this.router.navigate(['/login/']);
    }
  

  }
}
